import { createContext, ReactNode, useContext } from 'react';

export type IContentActionsType = 'Lesson' | 'Material' | 'Live' | 'Exercise';

interface IContentActionsContext {
  contentId?: string;
  contentSlug?: string;
  contentType: IContentActionsType;
}

const ContentActionsContext = createContext<IContentActionsContext>(
  {} as IContentActionsContext
);

export function useContentActionsContext() {
  return useContext(ContentActionsContext);
}

interface IContentActionsProviderProps {
  children: ReactNode;
  contentId?: string;
  contentSlug?: string;
  contentType: IContentActionsType;
}

export function ContentActionsProvider(props: IContentActionsProviderProps) {
  return (
    <ContentActionsContext.Provider
      value={{
        contentId: props.contentId,
        contentSlug: props.contentSlug,
        contentType: props.contentType,
      }}
    >
      {props.children}
    </ContentActionsContext.Provider>
  );
}
